export const iconFontAwesomeFruitsVegetablesPepperHot = (
	<i className="fa-solid fa-pepper-hot"></i>
);
